"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * Represents a parser warning, currently only used by ChordProParser.
 */


var ParserWarning = /*#__PURE__*/function () {
  /**
   * @hideconstructor
   */
  function ParserWarning(message, lineNumber) {
    _classCallCheck(this, ParserWarning);
    /**
     * The warning message
     * @member
     * @type {string}
     */


    this.message = message;
    /**
     * The chord sheet line number on which the warning occurred
     * @member
     * @type {integer}
     */

    this.lineNumber = lineNumber;
  }
  /**
   * Returns a stringified version of the warning
   * @returns {string} The string warning
   */


  _createClass(ParserWarning, [{
    key: "toString",
    value: function toString() {
      return "Warning: ".concat(this.message, " on line ").concat(this.lineNumber);
    }
  }]);

  return ParserWarning;
}();

var _default = ParserWarning;
exports["default"] = _default;